import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "../../models/auth/auth.model";

interface UsersStateType {
    isLoading: boolean
    users: User[]
    docsHistory: any[]
    userByEmail: User | null
    updateUserStatusSuccess: boolean
    updateVerifiedContactSuccess: boolean
    error: string
}

const initialState: UsersStateType = {
    isLoading: false,
    users: [],
    docsHistory: [null],
    userByEmail: null,
    updateUserStatusSuccess: false,
    updateVerifiedContactSuccess: false,
    error: ""
};

export const UsersSlice = createSlice({
    name: "Users",
    initialState: initialState,
    reducers: {
        setIsLoading: (state) => {
            state.isLoading = true;
        },
        getUsers: (state, action: PayloadAction<User[]>) => {
            state.isLoading = false;
            state.users = action.payload;
        },
        setDocsHistory: (state, action: PayloadAction<any>) => {
            state.docsHistory = action.payload;
        },
        getUserByEmailSuccess: (state, action: PayloadAction<User>) => {
            state.isLoading = false;
            state.userByEmail = action.payload;
        },
        updateUserStatusSuccess: (state) => {
            state.isLoading = false;
            state.updateUserStatusSuccess = true;
        },
        updateVerifiedContactSuccess: (state) => {
            state.isLoading = false;
            state.updateVerifiedContactSuccess = true;
        },
        setError: (state, action: PayloadAction<string>) => {
            state.isLoading = false;
            state.error = action.payload;
        },
        clearState: (state) => {
            state.isLoading = false;
            state.updateUserStatusSuccess = false;
            state.updateVerifiedContactSuccess = false;
            state.userByEmail = null;
            state.error = "";
        },
    }
});

export default UsersSlice.reducer;
export const {
    setIsLoading,
    getUsers,
    setDocsHistory,
    getUserByEmailSuccess,
    updateUserStatusSuccess,
    updateVerifiedContactSuccess,
    setError,
    clearState
} = UsersSlice.actions;